<div class="btn-group d-flex flex-row align-items-center justify-content-evenly ">
  <button class="m-btn btn btn-primary"><span style="background-color: transparent">Apply</span>Tuning
  </button>
  <button class="m-btn-s btn btn-light"><span style="background-color: transparent">Upload</span> Master
  </button>
</div>
